import React from "react";
import { Modal, Button } from "react-bootstrap";
import FormatDateTime from "../../functional/DateTimeFormatter";
import { history } from "../../../../helpers/history";

const AnnouncementModal = ({ onClose, announcement, showModal }) => {
  
  const createMarkup = (htmlString) => ({ __html: htmlString });
  return (
    <Modal
      show={showModal}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          Announcement Detail
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {announcement && (
          <div className="popup-border modalDetails">
            <div className="col-xs-12 m-b-5">
              <div className="row">
                <div className="col-xs-3 col-md-3">Headline:</div>
                <div className="col-xs-9 hideIfEmpty col-md-9">
                  <span>{announcement.Headline}</span>
                </div>
              </div>
            </div>
            <div className="col-xs-12 m-b-5">
              <div className="row">
                <div className="col-xs-3 col-md-3">Expiration Date:</div>
                <div className="col-xs-9 hideIfEmpty col-md-9">
                  <FormatDateTime
                    date={announcement.ExpirationDate}
                    format="MM/DD/YYYY"
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-12 m-b-5">
              <div className="row">
                <div className="col-xs-3 col-md-3">Announcement:</div>
                <div
                  className="col-xs-9 hideIfEmpty col-md-9"
                  dangerouslySetInnerHTML={createMarkup(
                    announcement.Announcement
                  )}
                ></div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => history.push("/Announcement")}>
          Go <i className="fa fa-arrow-right"></i>
        </Button>
        <Button variant="secondary" onClick={onClose}>
          {" "}
          Close{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default AnnouncementModal;
